export class Alert {
  type: AlertType;
  code: string;
  message: string;
}

export enum AlertType {
  Success,
  Error,
  Info,
  Warning
}
